import axios from "axios";

// const ENVIRONMENT = 'production';
// console.log("ALL ENV 👉", process.env);

const API_LIVE_SERVER = process.env.REACT_APP_API_SERVER_LIVE;
// console.log("BASE URL USED 👉", API_LIVE_SERVER);

// console.log("-------->",API_LIVE_SERVER)
const api = axios.create({
  baseURL: API_LIVE_SERVER,
  headers: {
    "Content-Type": "application/json",
  },
});

// 🔐 OPTIONAL AUTH (future safe)
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem("admin_token");

    // 🔁 token ho tabhi attach hoga
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  error => Promise.reject(error)
);

// 🚨 Global error handler (future use)
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      console.warn("Unauthorized – future token issue");
    }
    return Promise.reject(error);
  }
);

export default api;
